import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ComponentReviewCommentSchema = withDefaults({
  type: 'component-review-comment',
  fields: [
    {
      kind: 'attribute',
      name: 'body',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'thread',
      type: 'component-review-thread',
      options: {
        async: false,
        inverse: 'comments',
      },
    },
    {
      kind: 'belongsTo',
      name: 'author',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default ComponentReviewCommentSchema;
